import React from 'react'
import PropTypes from 'prop-types'

// Mounted even while empty: a live region that appears at the same moment as its text is not
// announced, and the toasts these messages also go to carry no aria-live of their own.
const LiveMessage = ({ message }) => (
  <div role="status" aria-live="polite" className="sr-only">{message || ''}</div>
)

LiveMessage.propTypes = {
  message: PropTypes.string,
}

export default LiveMessage
